let dateShortMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

export const formatDate = (date, type = 'default') => {
  let d = new Date(date)
  let month_index = d.getMonth()
  let month_abbr = dateShortMonths[month_index],
    month_number = (month_index + 1).toString().padStart(2, '0'),
    day = d.getDate().toString().padStart(2, '0'),
    year = d.getFullYear(),
    h = d.getHours(),
    m = d.getMinutes()
  if (m < 10) m = '0' + m

  // if (day.length < 2) day = '0' + day;
  // if(d.getTime() !== d.getTime()) return false; // isNaN

  if (type === 'default') {
    return [month_abbr, day + ',', year, h + ':' + m].join(' ')
  } else if (type === 'day') {
    return [month_abbr, day + ',', year].join(' ')
  } else if (type === 'mm/dd/yyyy') {
    return [month_number, day, year].join('/')
  } else if (type === 'date') {
    return [year, month_number, day].join('-')
  } else if (type === 'MMM. DD, YYYY') {
    return 'MMM. DD, YYYY'
  }
  // format = (ab) => {
  // }
  // DD MMM YYYY HH:mm
  // YYYY-MM-DD
  // var d = new Date(date),
  //     month = '' + (d.getMonth() + 1),
  //     day = '' + d.getDate(),
  //     year = d.getFullYear();
  //
  // if (month.length < 2) month = '0' + month;
  // if (day.length < 2) day = '0' + day;
  //
  // return [year, month, day].join('-');
}

export const formatDateTime = (date, type = '') => {
  if (!date) return ''
  let d = new Date(date)

  // let month_name = dateShortMonths[d.getMonth()];
  let month = d.getMonth() + 1,
    day = d.getDate(),
    year = d.getFullYear(),
    h = d.getHours(),
    m = d.getMinutes(),
    s = d.getSeconds()

  // if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day

  if (type === 'mm/dd/yyyy hh:mm')
    return `${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}/${year} ${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`
  return `${month <= 9 ? '0' + month : month}/${day < 10 ? '0' + day : day}/${year} ${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}`
}

export const formatOneDate = (theDate) => {
  let aDate = new Date(theDate)
  if (!aDate || !theDate) return false
  return (
    dateShortMonths[aDate.getMonth()] +
    '. ' +
    aDate.getDate() +
    ', ' +
    aDate.getFullYear()
  )
}

export const formatTwoDates = (beginDate, endDate) => {
  let bDate = new Date(beginDate)
  let eDate = new Date(endDate)
  let bYear = bDate.getFullYear(),
    eYear = eDate.getFullYear(),
    bDay = bYear + '-' + bDate.getMonth() + '-' + bDate.getDate(),
    eDay = eYear + '-' + eDate.getMonth() + '-' + eDate.getDate()
  // if(bDate.getTime() !== bDate.getTime()) return false;
  // let beginOn = formatDate(row['begin_on'], 'MMM. DD, YYYY');
  // let endOnValid = formatDate(row['end_on'], 'MMM. DD, YYYY');
  // if( beginOnValid !== false && endOnValid &&  moment(row['begin_on']).format('YYYY-MM-DD') ===  moment(row['end_on']).format('YYYY-MM-DD') ) {
  if (bDay === eDay) {
    return (
      dateShortMonths[bDate.getMonth()] + '. ' + bDate.getDate() + ', ' + bYear
    )
  } else if (bYear === eYear) {
    return (
      dateShortMonths[bDate.getMonth()] +
      '. ' +
      bDate.getDate() +
      ' - ' +
      dateShortMonths[eDate.getMonth()] +
      '. ' +
      eDate.getDate() +
      ', ' +
      eYear
    )
  } else {
    return (
      dateShortMonths[bDate.getMonth()] +
      '. ' +
      bDate.getDate() +
      ', ' +
      bYear +
      ' - ' +
      dateShortMonths[eDate.getMonth()] +
      '. ' +
      eDate.getDate() +
      ', ' +
      eYear
    )
  }
  // d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
}

export const formatDates = (beginDate, endDate) => {
  let bDate = new Date(beginDate) //  + 'T12:00:00.000'
  let eDate = new Date(endDate) //  + 'T12:00:00.000'
  let bYear = bDate.getFullYear(),
    eYear = eDate.getFullYear(),
    bDay = bYear + '-' + bDate.getMonth() + '-' + bDate.getDate(),
    eDay = eYear + '-' + eDate.getMonth() + '-' + eDate.getDate()
  // if(bDate.getTime() !== bDate.getTime()) return false;
  // let beginOn = formatDate(row['begin_on'], 'MMM. DD, YYYY');
  // let endOnValid = formatDate(row['end_on'], 'MMM. DD, YYYY');
  // if( beginOnValid !== false && endOnValid &&  moment(row['begin_on']).format('YYYY-MM-DD') ===  moment(row['end_on']).format('YYYY-MM-DD') ) {
  if (bDay === eDay) {
    return (
      dateShortMonths[bDate.getMonth()] + '. ' + bDate.getDate() + ', ' + bYear
    )
  } else if (bYear === eYear) {
    return (
      dateShortMonths[bDate.getMonth()] +
      '. ' +
      bDate.getDate() +
      ' - ' +
      dateShortMonths[eDate.getMonth()] +
      '. ' +
      eDate.getDate() +
      ', ' +
      eYear
    )
  } else {
    return (
      dateShortMonths[bDate.getMonth()] +
      '. ' +
      bDate.getDate() +
      ', ' +
      eYear +
      ' - ' +
      dateShortMonths[eDate.getMonth()] +
      '. ' +
      eDate.getDate() +
      ', ' +
      eYear
    )
  }
  // d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
}

export const formatTimes = (beginTime, endTime) => {
  let bTime = new Date(beginTime)
  let eTime = new Date(endTime)
  return (
    bTime.getHours() +
    ':' +
    ('0' + bTime.getMinutes()).slice(-2) +
    '-' +
    eTime.getHours() +
    ':' +
    ('0' + eTime.getMinutes()).slice(-2)
  )
}

export const bidNumber = () => {
  const d = new Date()
  // const monthIndex = d.getMonth()
  // const month_abbr = dateShortMonths[month_index]
  // const monthNumber = (monthIndex + 1).toString().padStart(2, '0')
  const year = d.getFullYear() // .toString().slice(2)
  return `${year}a${getRandomInt(0, 999).toString().padStart(3, '0')}` // ${crypto.randomUUID().slice(0, 3)}
  // return `${year}${monthNumber}${crypto.randomUUID().slice(0, 3)}`
}

function getRandomInt(min, max) {
  // +1 makes the 'max' value inclusive
  return Math.floor(Math.random() * (max - min + 1)) + min
}
